import { Box, Stack } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import useGetDeviceInfo from "hooks/useGetDeviceInfo";
import { theme } from "styles/theme";
import ContentTemplateV2 from "../content/ContentTemplateV2";
import image19 from "static/image/payment/typec/660_19.png";
import image20 from "static/image/payment/typec/660_20.png";
import numWithCircle1Img from "../../../static/image/payment/NumWithCircle_1.svg";
import numWithCircle2Img from "../../../static/image/payment/NumWithCircle_2.svg";
import numWithCircle3Img from "../../../static/image/payment/NumWithCircle_3.svg";
import numWithCircle4Img from "../../../static/image/payment/NumWithCircle_4.svg";
import numWithCircle5Img from "../../../static/image/payment/NumWithCircle_5.svg";
import FloatingAreaPromotion from "../../common/FloatingAreaPromotion";
import PromotionPaymentButton from "../../../pages/promotion/PromotionPaymentButton";
import CustomTypography from "../../common/CustomTypography";
import checkIconImg from "../../../static/image/payment/Check.svg";
import image1 from "../../../static/image/payment/typec/660_1.png";
import image2 from "../../../static/image/payment/typec/660_2.png";
import image3 from "../../../static/image/payment/typec/660_3.png";
import image4 from "../../../static/image/payment/typec/660_4.png";
import image5 from "../../../static/image/payment/typec/660_5.png";
import image6 from "../../../static/image/payment/typec/660_6.png";
import image7 from "../../../static/image/payment/typec/660_7.png";
import image8 from "../../../static/image/payment/typec/660_8.gif";
import image9 from "../../../static/image/payment/typec/660_9.png";
import image10 from "../../../static/image/payment/typec/660_10.png";
import image11 from "../../../static/image/payment/typec/660_11.png";
import image12 from "../../../static/image/payment/typec/660_12.png";
import image13 from "../../../static/image/payment/typec/660_13.png";
import image14 from "../../../static/image/payment/typec/660_14.png";
import image15 from "../../../static/image/payment/typec/660_15.png";
import image16 from "../../../static/image/payment/typec/660_16.png";
import image17 from "../../../static/image/payment/typec/660_17.png";
import image18 from "../../../static/image/payment/typec/660_18.png";
import { trackCapiStandardEvent } from "analytics/metaCapi";

const numberWithCircle = [
  numWithCircle1Img,
  numWithCircle2Img,
  numWithCircle3Img,
  numWithCircle4Img,
  numWithCircle5Img,
];

const majorTrainingPlan = [
  "내적 변화를 알아차리기",
  "주의력을 통제하며 경험을 분리하기",
  "생각을 심리적 사건으로 바라보기",
  "회피하지 않고 기꺼이 받아들이기",
  "삶의 가치를 향해 전념하기",
];

const programFeatures = [
  {
    main: "인지심리학 핵심 이론",
  },
  {
    main: "전담 코치의 1:1 지원",
  },
  {
    main: "감정, 신체 안정화 도구",
  },
  {
    main: "기술 연습을 위한 명상",
  },
  {
    main: "실생활 적용을 위한 기록지",
  },
];

export default function PaymentContentPagePromotion({
  isFromOnboarding = false,
}: {
  isFromOnboarding?: boolean;
}) {
  const floatingAreaRef = useRef<HTMLDivElement>(null);
  const isInappWebview = true;
  const fullWidth = true;

  const pageKey = "payment_1";

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    trackCapiStandardEvent('AddToCart');
  });

  const { homeIndicatorHeight } = useGetDeviceInfo();
  const [containerHeight, setContainerHeight] = useState<number>(
    window.innerHeight - homeIndicatorHeight
  );
  const [floatingAreaHeight, setFloatingAreaHeight] = useState<number>(0);

  useEffect(() => {
    setTimeout(() => {
      setFloatingAreaHeight(floatingAreaRef.current?.offsetHeight || 0);
    }, 100);
  }, [floatingAreaRef.current]);

  return (
    <ContentTemplateV2
      noPadding
      noBottomPaddingChildren
      isWide
      setContainerHeight={setContainerHeight}
    >
      {containerHeight > 0 && (
        <Stack
          sx={{
            backgroundColor: theme.vars.palette.Background.Level3,
          }}
        >
          <Stack
            justifyContent="center"
            alignItems={"center"}
            sx={{
              width: "100%",
              maxWidth: "660px",
              mx: "auto",
            }}
          >
            {/*영역 1: ~님의 프로그램 */}
            <Stack
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                width: "100%",
                maxWidth: "100%",
                mx: "auto",
                px: isInappWebview ? 3.5 : 6,
                pt: 6,
                pb: 8,
              }}
            >
              <Stack
                spacing={3}
                sx={{
                  width: "100%",
                  maxWidth: "660px",
                  textAlign: "center",
                }}
              >
                <CustomTypography
                  variant={"H1"}
                  sx={{
                    paddingTop: "54px",
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 800,
                  }}
                >
                  {`나의 프로그램`}
                </CustomTypography>
                {/* 서브타이틀 문구 변경 */}
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.Medium,
                    fontWeight: 500,
                  }}
                >
                  {"마음을 다루는 근거있고\n" + "효과적인 방법을 제안합니다."}
                </CustomTypography>
              </Stack>

              <Stack
                spacing={"12px"}
                sx={{
                  width: "100%",
                  maxWidth: "660px",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: theme.vars.palette.Surface.Forward,
                    borderRadius: "16px",
                    py: 4,
                    px: 3,
                  }}
                >
                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    주요 훈련 계획
                  </CustomTypography>
                  <Stack spacing={1} sx={{ mt: 2 }}>
                    {majorTrainingPlan.map((text, idx) => (
                      <Stack
                        key={idx}
                        direction={"row"}
                        spacing={0.5}
                        alignItems="center"
                      >
                        <img
                          src={numberWithCircle[idx]}
                          alt={"number"}
                          style={{}}
                        />
                        <CustomTypography
                          variant={"Body"}
                          sx={{
                            p: 0,
                            color: theme.vars.palette.Content.Strong,
                            fontWeight: 500,
                          }}
                        >
                          {text}
                        </CustomTypography>
                      </Stack>
                    ))}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    backgroundColor: theme.vars.palette.Surface.Forward,
                    borderRadius: "16px",
                    py: 4,
                    px: 3,
                  }}
                >
                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    프로그램 구성
                  </CustomTypography>
                  <Stack spacing={1} sx={{ mt: 2 }}>
                    {programFeatures.map(({ main }, idx) => (
                      <Stack
                        key={idx}
                        direction="row"
                        alignItems="center"
                        spacing={0.5}
                      >
                        <img src={checkIconImg} alt={"checkImg"} />
                        <CustomTypography sx={{ p: 0 }}>
                          <CustomTypography
                            variant={"Body"}
                            sx={{
                              p: 0,
                              color: theme.vars.palette.Content.Strong,
                              fontWeight: 500,
                            }}
                          >
                            {main}
                          </CustomTypography>
                        </CustomTypography>
                      </Stack>
                    ))}
                  </Stack>
                </Box>
              </Stack>
            </Stack>
            <img
              src={image1}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image2}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image3}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image4}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image5}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />{" "}
            <img
              src={image6}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />{" "}
            <img
              src={image7}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />{" "}
            <img
              src={image8}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image9}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image10}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image11}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image12}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image13}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image14}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image15}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image16}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image17}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image18}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image19}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image20}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
          </Stack>

          <FloatingAreaPromotion
            fullWidth={fullWidth}
            ref={floatingAreaRef}
            noDivider={true}
            // paddingBottom={isInappWebview ? "4px" : "12px"}
            backgroundColor={"transparent"}
            paddingBottom={"8px"}
          >
            <Stack
              spacing={1.5}
              sx={{ width: "100%" }}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Stack
                spacing={"16px"}
                sx={{
                  width: "100%",
                  mx: "auto",
                  paddingBottom: "8px",
                }}
                alignItems="center"
                justifyContent={"space-between"}
              >
                <PromotionPaymentButton selectedPlan={"challenger"} />
              </Stack>
            </Stack>
          </FloatingAreaPromotion>
        </Stack>
      )}
    </ContentTemplateV2>
  );
}
